import { useNavigate } from "react-router-dom";
import { Button, Text } from "@chakra-ui/react";
import { addNewOrganizationsCardsData } from "../../../utils/constants";
import {
  AddNewOrganizationWrapper,
  AddOrganizationCard,
  CardsLayout,
  PageTitle,
  BackButtonWrapper,
} from "./styles";
import { Back } from "../../../Components/Back/Back";
import { useTierLimits } from "../../../hooks/useTierLimits";

export const AddNewOrganization = () => {
  const navigate = useNavigate();
  const tierInfo = useTierLimits();
  const canAddOrganization = tierInfo.isPaid || tierInfo.limits.organizations.canAdd;

  if (!canAddOrganization) {
    return (
      <AddNewOrganizationWrapper>
        <BackButtonWrapper>
          <Back />
        </BackButtonWrapper>
        <PageTitle data-cy="cypress-new-org-page-header">Add organization</PageTitle>
        <Text mb={4} color="gray.600">
          Free tier: You can have 1 organization. Upgrade to paid ($19/month) to add more organizations.
        </Text>
        <Button colorScheme="primary" onClick={() => navigate("/my-organizations")}>
          Back to My Organizations
        </Button>
      </AddNewOrganizationWrapper>
    );
  }

  return (
    <AddNewOrganizationWrapper>
      <BackButtonWrapper>
        <Back />
      </BackButtonWrapper>
      <PageTitle data-cy='cypress-new-org-page-header'>What kind of organization would you like to add?</PageTitle>
      <CardsLayout>
        {addNewOrganizationsCardsData.map((cardData, id) => {
          const Illustration = cardData.illustration;
          return (
            <AddOrganizationCard
              onClick={() =>
                navigate(`/organizations/new/form`, {
                  state: {
                    type: cardData.title.toLowerCase(),
                  },
                })
              }
              key={id}
            >
              <div className="illustration-container">
                <Illustration />
              </div>
              <div className="title" data-cy={`cypress-card-title-${id}`}>{cardData.title}</div>
              <div className="description" data-cy={`cypress-card-description-${id}`}>{cardData.description}</div>
            </AddOrganizationCard>
          );
        })}
      </CardsLayout>
    </AddNewOrganizationWrapper>
  );
};
